// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['jquery', 'nprogress', 'lodash4'], function($, nprogress, _){
var E = {};

var load_container = $('<div class=loader-container>'
    +'<span class=loader-text>Loading...</span></div>');
$('body').prepend(load_container);
load_container.hide();
nprogress.configure({showSpinner: false});

E.debug = false;
E.config = function(opt){ nprogress.configure(opt); };
E.tasks = {};
var tasks = E.tasks;
var last_progress;
E.task_current = null;
E.text_cb = function(text){ return text; };
E.start = function(opt){
    opt = opt||{};
    if (!_.isObject(opt))
        opt = {name: arguments[0]};
    var task = get_task(opt);
    if (task)
        return task.update(opt);
    return tasks[opt.name] = new Task(opt);
};
E.get = function(name){ return get_task({name: name}); };
E.update = function(opt){
    return get_task(opt, true).update(opt);
};
E.end = function(opt){
    if (!_.isObject(opt))
        opt = {name: arguments[0]};
    var task = get_task(opt, !opt.no_throw);
    if (task)
        task.end();
};
E.end_all = function(){
    _.forEach(tasks, function(task){ hide_container(task.container); });
    tasks = E.tasks = {};
    E.task_current = null;
};
function get_task(opt, required){
    opt.name = opt.name||'default';
    var task = tasks[opt.name];
    if (!task && required)
        throw new Error('Task "'+opt.name+'" does not exist');
    return task;
}
function hide_container(container){
    if (container)
        return $('.loader-container', container).remove();
    load_container.hide();
    if (last_progress)
    {
        nprogress.done();
        last_progress = null;
    }
}
function task_hint(opt){
    var task = null;
    var priority = -Infinity;
    for (var name in tasks)
    {
        var t = tasks[name];
        if (opt.container!=t.container || t.priority<=priority)
            continue;
        priority = t.priority;
        task = t;
    }
    if (!opt.container)
        E.task_current = task;
    if (!task)
        return hide_container(opt.container);
    show_task(task);
}
function Task(opt){
    _.extend(this, opt);
    this.priority = this.priority||0;
    this.hint = this.hint||'Loading...';
    if (E.debug)
    {
        this.time_start = Date.now();
        console.log('__start', this.name);
    }
    tasks[this.name] = this;
    task_hint(this);
}
Task.prototype.update = function(opt){
    _.extend(this, opt);
    if (E.debug)
        console.log('__update', this.name, this.progress||'');
    task_hint(this);
    return this;
};
Task.prototype.end = function(){
    if (E.debug)
    {
        var time = Date.now()-this.time_start;
        time = time>=1000 ? Math.round(time/100)/10+'s' : time+'ms';
        console.log('__end', this.name, time);
    }
    delete tasks[this.name];
    task_hint({container: this.container});
};
function show_task(task){
    set_progress(task.progress);
    var container = $(task.container);
    container = container.length ? container : load_container;
    var position = task.position || 'absolute';
    set_container_hint(container, task.hint, position.toLowerCase());
}
function set_container_hint(container, hint, position){
    var allow_position = ['fixed', 'relative', 'absolute'];
    if (!position || !allow_position.includes(position))
        position = 'absolute';
    if (container==load_container && !container.is(':visible'))
        container.show();
    var $el = $('.loader-text', container);
    if ($el.length)
        return $el.text(E.text_cb(hint));
    container.css('position', 'relative');
    load_container.clone().css('position', position).show()
    .prependTo(container).find('.loader-text').text(E.text_cb(hint));
}
function set_progress(p){
    if (p)
    {
        last_progress = p;
        nprogress.set(p);
        return;
    }
    if (last_progress)
    {
        last_progress = null;
        nprogress.remove();
    }
}

return E; }); // eslint-disable-line
